module.exports = __webpack_public_path__ + "img/V57.dc2ada26.jpg";